<template>
  <div id="landing" class="row">
    <div id="sideBar" class="col-1">
      <b-dropdown variant="light">
        <template v-slot:button-content>
          <img width="65" height="65" src="img/arc360_icon.png">
        </template>
        <b-dropdown-item disabled>Contact Us</b-dropdown-item>
        <b-dropdown-item @click="logout">Logout</b-dropdown-item>
      </b-dropdown>
      <br>
      <b-nav vertical class="col-12 ">
        <div class="" v-for="(item, index) in activeTabFlags">
          <b-nav-item class="col-12">
            <b-button variant="outline-dark" :pressed="item.value"  size="sm" class="selectedButton col-12 " v-on:click="sideBarClick(index)">{{item.label}}</b-button>
          </b-nav-item>
        </div>
      </b-nav>
    </div>
    <div id="embeddedContent" class="col-11" v-for="(item, index) in Object.keys(activeTabFlags)" v-show="activeTabFlags[item].value==true">
      <template>
        <vue-friendly-iframe :src="activeTabFlags[item].link" className="embeddedItem"></vue-friendly-iframe>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LandingPage',
  components: {

  },
  data() {
    return {

    }
  },
  computed: {
    activeTabFlags: {
      get() {
        return this.$store.state.mainStore.activeTabFlags
      }
    },
  },
  methods: {
    sideBarClick(index) {
      const current = this
      current.$store.commit("mainStore/setActiveTabFlag", index)
      console.log(current.activeTabFlags);
    },
    logout() {
      console.log("logout clicked");
      const current = this
      current.$store.commit("mainStore/storeAccessToken", "")
      sessionStorage.removeItem("accessToken")
      current.$router.push("/")
      current.$notify({
        group: 'notification_01',
        title: 'Logout Successful',
        text: '',
        type: "success",
        duration: 1500
      });
    }
  }
}
</script>

<style>
#landing {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
  height: 100vh!important;
  width: 100vw!important;
  max-height: 100vh!important;
  background-color: white;
}
#sideBar {
  background-color: #f8f9fa;
  padding:0;

}
#embeddedContent {
  /* max-width: 5vw!important; */
  /* height: 99vh!important;
  width: 100vh!important; */
  /* overflow:none; */

  padding: 0.5px!important;
  border: solid;
}
.embeddedItem {
  height: 99vh!important;
  width: 91.67vw!important;
}
.frameContainerClass {
  padding:3px!important;
  border-color: #404952;
  border-style: solid;
}
.selectedButton:hover, .selectedButton.active {
  background-color: #e36010!important;
  border-color: #e36010!important;
}
</style>
